import React, { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
// customer
import CustomerProfile from "./pages/user/Profile";
import CustomerSignup from "./components/user/Signup";
import CustomerLogout from "./components/user/Logout";
import WishlistPage from "./pages/user/WishlistPage";
import MyOrderPage from "./pages/user/MyOrderPage";
import MyOrderDetails from "./pages/user/MyOrderDetails";
import CheckoutPage from "./pages/user/CheckoutPage";
import CartPage from "./pages/user/CartPage";
import ProductDetailsPage from "./pages/user/ProductDetails";
//admin
import AdminBrand from "./components/admin/Brand";
import AdminCategory from "./components/admin/Category";
import AdminDashboard from "./components/admin/Dashboard";
import AdminEditProduct from "./components/admin/EditProduct";
import SubAdminEditShop from "./components/admin/EditUser";
import AdminItemsReport from "./components/admin/ItemsReport";
// import AdminLogin from './components/admin/Login'
import AdminLogout from "./components/admin/Logout";
import AdminOrderDetails from "./components/admin/OrderDetails";
import AdminOrders from "./components/admin/Orders";
import AdminProduct from "./components/admin/Product";
import AdminProductReport from "./components/admin/ProductsReport";
import AdminProfile from "./components/admin/Profile";
import ShopOrders from "./components/admin/ShopOrders";
import UsersProfile from "./components/admin/UserManagement";

//super
import SuperAdminAddCategory from "./components/super/AddCategory";
import SuperAdminAddProduct from "./components/super/AddProduct";
import SuperAdminAddServiceCategory from "./components/super/AddServiceCategory";
import SuperAdminAddShop from "./components/super/AddShop";
import SuperAdminAddSlide from "./components/super/AddSlide";
import SuperAdminAddVoucher from "./components/super/AddVoucher";
import SuperAdminBrand from "./components/super/Brand";
import SuperAdminCategory from "./components/super/Category";
import SuperAdminNavigation from "./components/super/Navigation";
import SuperAdminCustomer from "./components/super/Customer";
// import CustomerEditForm from './components/super/userEditForm'
// import CustomerLoyaltyPoints from './components/super/userLoyalPoints'
// import CustomerTypePermissions from './components/super/userPermissions'
import SuperAdminDashboard from "./components/super/Dashboard";
import SuperAdminEditCategory from "./components/super/EditCategory";
import SuperAdminEditServiceCategory from "./components/super/EditServiceCategory";
import SuperAdminEditShop from "./components/super/EditShop";
import SuperAdminEditSlide from "./components/super/EditSlide";
import SuperAdminEditVoucher from "./components/super/EditVoucher";
import SuperAdminHomePage from "./components/super/HomePage";
import Invoice from "./components/super/Invoice";
import ItemsReport from "./components/super/ItemsReport";
// import SuperAdminLogin from './components/super/Login'
import SuperAdminLogout from "./components/super/Logout";
import Orders from "./components/super/Orders";
import SuperPagesComponent from "./components/super/Pages";
import Payment from "./components/super/Payments";
import SuperAdminProduct from "./components/super/Products";
import ProductReport from "./components/super/ProductsReport";
import SuperAdminServiceCategory from "./components/super/ServiceCategory";
import ServiceItemReport from "./components/super/ServiceItemReport";
import SuperServiceOrderDetails from "./components/super/ServiceOrderDetails";
import SuperServiceOrders from "./components/super/ServiceOrders";
import ServiceOrManpower from "./components/super/ServiceOrManpower";
import ServiceReport from "./components/super/ServiceReport";
import Settings from "./components/super/Settings";
import Shipping from "./components/super/Shipping";
import SuperAdminShop from "./components/super/Shop";
import SuperAdminSlide from "./components/super/Slide";
import Tracking from "./components/super/Tracking";
import UserFinancialReport from "./components/super/UsersFinancialReport";
import SuperAdminVoucher from "./components/super/Voucher";
import Wallet from "./components/super/Wallet";
import SuperNotificationForm from "./components/super/NotificationHistory";
import SuperAdminNotification from "./components/super/Notification";
import LoyaltyPointsSettings from "./components/super/LoyaltyPointsSettings";
import SuperAdminAddNavigation from "./components/super/AddNavigation";
import SuperAdminEditNavigation from "./components/super/EditNavigation";
import SuperLogin from "./components/super/SuperLogin";
import AdminLogin from "./components/admin/AdminLogin";
import { onMessage } from "firebase/messaging";
import { toast, ToastContainer } from "react-toastify";
import { messaging } from "./components/notifications/firebase";
import {
  ADMIN,
  ADMIN_TOKEN,
  CUSTOMER,
  CUSTOMER_TOKEN,
  EDIT,
  SUPER_ADMIN,
  SUPER_ADMIN_TOKEN,
} from "./include/constant";
import {
  getAdmin,
  getCustomer,
  getSuperAdmin,
  isEmptyObj,
  setToLocalStorage,
} from "./include/function";

// Styles

import "./styles/App.css";
import "./styles/LargeScreen.css";
import "./styles/MediumScreen.css";
import "./styles/SideNavBar.css";
import "./styles/SmallScreen.css";

import HomePage from "./pages/Home";
import ShopPage from "./pages/template/ShopPage";
import ProductDetailsPageTwo from "./pages/template/ProductDetailsPageTwo";
// import CheckoutPage from "./pages/template/CheckoutPage";
import AccountPage from "./pages/template/AccountPage";
import BlogPage from "./pages/template/BlogPage";
import BlogDetailsPage from "./pages/template/BlogDetailsPage";
import ContactPage from "./pages/template/ContactPage";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import VendorPage from "./pages/template/VendorPage";
import VendorDetailsPage from "./pages/template/VendorDetailsPage";
import VendorTwoPage from "./pages/template/VendorTwoPage";
import VendorTwoDetailsPage from "./pages/template/VendorTwoDetailsPage";
import BecomeSellerPage from "./pages/template/BecomeSellerPage";
import PlaceOrder from "./pages/user/PlaceOrder";
import CategoryProductListPage from "./pages/user/CategoryProductList";
import Search from "./pages/user/Search";
import Login from "./components/user/Login";
import AllCategoryProductListPage from "./pages/user/AllCategoryProductList";
import BannerCategoryProductListPage from "./pages/user/BannerCategoryProductList";
import ComparePage from "./components/user/ComparePage";
import OrderSummaryPage from "./pages/user/OrderSummaryPage";
import NotificationPage from "./pages/user/NotificationPage";
import AddBrand from "./components/admin/AddBrand";
import AddCategory from "./components/admin/AddCategory";
import AddProduct from "./components/admin/AddProduct";
import AddSlide from "./components/admin/AddSlide";
import ListCategory from "./components/admin/ListCategory";
import ListProduct from "./components/admin/ListProduct";
import ListBrand from "./components/admin/ListBrand";
import ListSlide from "./components/admin/ListSlide";
import AdminViewProduct from "./components/admin/ViewProduct";
import ListInvoice from "./components/admin/ListInvoice";
import ListPayment from "./components/admin/ListPayment";
import ListPaymentProof from "./components/admin/ListPaymentProof";
import PaymentProofReview from "./components/admin/PaymentProofReview";
import PaymentDetails from "./components/admin/PaymentDetails";
import InvoiceDetail from "./components/admin/InvoiceDetail";
import ListCustomer from "./components/admin/ListCustomer";
import CustomerDetails from "./components/admin/CustomerDetails";
import AddDelivery from "./components/admin/AddDelivery";
import ListDeliveryCharges from "./components/admin/ListDeliveryCharges";
import ListPincode from "./components/admin/ListPincode";
import AddPincode from "./components/admin/AddPincode";
import ListDocument from "./components/admin/ListDocument";
import DocumentVerify from "./components/admin/DocumentVerify";
import ListRole from "./components/admin/ListRole";
import AddRole from "./components/admin/AddRole";
import ListUser from "./components/admin/ListUser";
import AddUser from "./components/admin/AddUser";
import ListCoupon from "./components/admin/ListCoupon";
import AddCoupon from "./components/admin/AddCoupon";
import CouponDetails from "./components/admin/CouponDetails";
import ReportProduct from "./components/admin/ReportProduct";
import ReportCustomer from "./components/admin/ReportCustomer";
import ReportSales from "./components/admin/ReportSales";
import AddNotification from "./components/admin/AddNotification";
import ListNotification from "./components/admin/ListNotification";
import AdminLogs from "./components/admin/AdminLogs";
import ListAuditLog from "./components/admin/ListAuditLog";
import PrivacyPolicy from "./pages/user/PrivacyPolicy";
import Terms from "./pages/user/Terms";
import ReturnPolicy from "./pages/user/ReturnPolicy";
import CancellationPolicy from "./pages/user/CancellationPolicy";
import FrequentlyAskedQuestion from "./components/user/FrequentlyAskedQuestion";
import AccountDeletion from "./components/user/AccountDeletion";

function App() {
  const [customer, setCustomer] = useState(getCustomer());
  const [admin, setAdmin] = useState(getAdmin());
  const [superAdmin, setSuperAdmin] = useState(getSuperAdmin());

  const handleCustomer = (customer, token) => {
    setToLocalStorage(CUSTOMER, customer);
    setToLocalStorage(CUSTOMER_TOKEN, token);
    setTimeout(() => {
      setCustomer(customer);
    }, 500);
  };

  const handleAdmin = (admin, token) => {
    setToLocalStorage(ADMIN, admin);
    setToLocalStorage(ADMIN_TOKEN, token);
    setTimeout(() => {
      setAdmin(admin);
    }, 500);
  };

  const handleSuperAdmin = (superAdmin, token) => {
    setToLocalStorage(SUPER_ADMIN, superAdmin);
    setToLocalStorage(SUPER_ADMIN_TOKEN, token);
    setTimeout(() => {
      setSuperAdmin(superAdmin);
    }, 500);
  };

useEffect(() => {
  onMessage(messaging, (payload) => {
    console.log("Payload:", payload);

    // Fallback if body or image is missing
    const body = payload.notification?.body || "No message content";
    const title = payload.notification?.title || "New Notification";
    const image = payload.notification?.image?.trim(); // Trim trailing spaces
    const url = payload.data?.click_url?.trim(); // Trim trailing spaces

    if (!isEmptyObj(customer)) {
      if (image) {
        toast(
          <>
            <div 
              onClick={() => {
                if (url) {
                  // For external links / new tab
                  window.open(url);
                  
                  // OR if using React Router for internal navigation:
                  // navigate(url); 
                }
              }}
              style={{ cursor: 'pointer' }}
            >
              <p>{body}</p>
              <p>{title}</p>
              <img src={image} alt="Notification" style={{ width: "50px" }} />
            </div>
          </>,
          {
            onClick: () => url && window.open(url), // Make toast itself clickable too
            autoClose: 5000,
          }
        );
      } else {
        toast(body + " - " + title, {
          onClick: () => url && window.open(url, '_blank'),
        });
      }
    }
  });
}, []);

  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <PhosphorIconInit />

      <Routes>
        {/* user */}
        <Route exact path="/" element={<HomePage />} />
        <Route
          path="/login"
          element={
            isEmptyObj(customer) ? (
              <Login handleCustomer={handleCustomer} />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/register"
          element={
            isEmptyObj(customer) ? (
              <CustomerSignup handleCustomer={handleCustomer} />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/logout"
          element={
            isEmptyObj(customer) ? (
              <Navigate to="/" />
            ) : (
              <CustomerLogout setCustomer={setCustomer} />
            )
          }
        />
        <Route
          path="/profile/personal-info"
          element={
            <AuthRoute
              user={customer}
              element={<CustomerProfile />}
              navigate="/login"
            />
          }
        />
        <Route
          path="/category-products/:categoryID"
          element={<CategoryProductListPage />}
        />
         <Route
          path="/category-products/:categoryID/:brandID"
          element={<CategoryProductListPage />}
        />
        <Route path="/compare-page" element={<ComparePage />} />
        <Route
          path="/category-banner-products/:categoryID"
          element={<BannerCategoryProductListPage />}
        />
        <Route
          path="/category-products"
          element={<AllCategoryProductListPage />}
        />
        <Route
          path="/product-details/:productID"
          element={<ProductDetailsPage />}
        />
        <Route path="/search-list" element={<Search />} />

        <Route
          path="/Orders"
          element={
            <AuthRoute
              user={customer}
              element={<MyOrderPage />}
              navigate="/login"
            />
          }
        />
        <Route
          path="/order-summary"
          element={
            <AuthRoute
              user={customer}
              element={<OrderSummaryPage />}
              navigate="/login"
            />
          }
        />
        <Route
          path="/user-notification"
          element={
            <AuthRoute
              user={customer}
              element={<NotificationPage />}
              navigate="/login"
            />
          }
        />

        <Route
          path="/OrderDetails/:id"
          element={
            <AuthRoute
              user={customer}
              element={<MyOrderDetails />}
              navigate="/login"
            />
          }
        />

        <Route
          path="/Checkout"
          element={
            <AuthRoute
              user={customer}
              element={<CheckoutPage />}
              navigate="/login"
            />
          }
        />
        <Route
          path="/orderPlaced"
          element={
            <AuthRoute
              user={customer}
              element={<PlaceOrder />}
              navigate="/login"
            />
          }
        />
        <Route
          path="/privacyPolicy"
          element={<AuthRoute element={<PrivacyPolicy />} navigate="/login" />}
        />
        <Route
          path="/termsAndCondition"
          element={<AuthRoute element={<Terms />} navigate="/login" />}
        />
        <Route
          path="/returnPolicy"
          element={<AuthRoute element={<ReturnPolicy />} navigate="/login" />}
        />
        <Route
          path="/cancellationPolicy"
          element={
            <AuthRoute element={<CancellationPolicy />} navigate="/login" />
          }
        />
        <Route
          path="/frequentlyAskedQuestion"
          element={
            <AuthRoute
              element={<FrequentlyAskedQuestion />}
              navigate="/login"
            />
          }
        />
        <Route
          path="/accountDeletion"
          element={
            <AuthRoute element={<AccountDeletion />} navigate="/login" />
          }
        />

        {/* Admin */}
        <Route
          path="/admin/login"
          element={
            isEmptyObj(admin) ? (
              <AdminLogin handleAdmin={handleAdmin} />
            ) : (
              <Navigate to="/admin" />
            )
          }
        />
        <Route
          path="/admin/logout"
          element={
            isEmptyObj(admin) ? (
              <Navigate to="/admin" />
            ) : (
              <AdminLogout setAdmin={setAdmin} />
            )
          }
        />
        <Route
          path="/admin/order"
          element={
            <AuthRoute
              user={admin}
              element={<AdminOrders />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/order-details/:id"
          element={
            <AuthRoute
              user={admin}
              element={<AdminOrderDetails />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/invoice-details/:id"
          element={
            <AuthRoute
              user={admin}
              element={<InvoiceDetail />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/product"
          element={
            <AuthRoute
              user={admin}
              element={<AdminProduct />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/deliveryCharge/deliveryChargeAddNew"
          element={
            <AuthRoute
              user={admin}
              element={<AddDelivery />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/deliveryCharge/deliveryChargeAddNew/:id"
          element={
            <AuthRoute
              user={admin}
              element={<AddDelivery />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/pincode/pincodeAddNew"
          element={
            <AuthRoute
              user={admin}
              element={<AddPincode />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/product/productAddNew"
          element={
            <AuthRoute
              user={admin}
              element={<AddProduct />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/reports/reportProducts"
          element={
            <AuthRoute
              user={admin}
              element={<ReportProduct />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/reports/reportCustomer"
          element={
            <AuthRoute
              user={admin}
              element={<ReportCustomer />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/reports/reportSales"
          element={
            <AuthRoute
              user={admin}
              element={<ReportSales />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/product/view/:id"
          element={
            <AuthRoute
              user={admin}
              element={<AdminViewProduct />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/product/edit/:id"
          element={
            <AuthRoute
              user={admin}
              element={<AdminEditProduct />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/edit-product/:id"
          element={
            <AuthRoute
              user={admin}
              element={<AdminEditProduct />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/profile"
          element={
            <AuthRoute
              user={admin}
              element={<AdminProfile />}
              navigate="/admin/login"
            />
          }
        />
        <Route path="/admin" element={<Navigate to="/admin/dashboard" />} />
        <Route
          path="/admin/dashboard"
          element={
            <AuthRoute
              user={admin}
              element={<AdminDashboard />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/sales/orders"
          element={
            <AuthRoute
              user={admin}
              element={<ShopOrders from="sales" />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/category"
          element={
            <AuthRoute
              user={admin}
              element={<AdminCategory from="catalogue" />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/brand"
          element={
            <AuthRoute
              user={admin}
              element={<AdminBrand from="catalogue" />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/brand/brandAddNew"
          element={
            <AuthRoute
              user={admin}
              element={<AddBrand />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/role/roleAddNew"
          element={
            <AuthRoute
              user={admin}
              element={<AddRole />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/notification/notificationSendNew"
          element={
            <AuthRoute
              user={admin}
              element={<AddNotification />}
              navigate="/admin/login"
            />
          }
        />

        <Route
          path="/admin/category/categoryList"
          element={
            <AuthRoute
              user={admin}
              element={<ListCategory />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/notification/notificationList"
          element={
            <AuthRoute
              user={admin}
              element={<ListNotification />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/user/userList"
          element={
            <AuthRoute
              user={admin}
              element={<ListUser />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/deliveryCharge/deliveryChargeList"
          element={
            <AuthRoute
              user={admin}
              element={<ListDeliveryCharges />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/pincode/pincodeList"
          element={
            <AuthRoute
              user={admin}
              element={<ListPincode />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/content/contentList"
          element={
            <AuthRoute
              user={admin}
              element={<ListSlide />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/brand/brandList"
          element={
            <AuthRoute
              user={admin}
              element={<ListBrand />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/role/roleList"
          element={
            <AuthRoute
              user={admin}
              element={<ListRole />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/product/productList"
          element={
            <AuthRoute
              user={admin}
              element={<ListProduct />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/sales/payment"
          element={
            <AuthRoute
              user={admin}
              element={<ListPayment />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/sales/payment/:id"
          element={
            <AuthRoute
              user={admin}
              element={<PaymentDetails />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/sales/paymentProof"
          element={
            <AuthRoute
              user={admin}
              element={<ListPaymentProof />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/sales/paymentProof/:id"
          element={
            <AuthRoute
              user={admin}
              element={<PaymentProofReview />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/sales/invoice"
          element={
            <AuthRoute
              user={admin}
              element={<ListInvoice />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/customer/customerList"
          element={
            <AuthRoute
              user={admin}
              element={<ListCustomer />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/customer/customerDetails/:id"
          element={
            <AuthRoute
              user={admin}
              element={<CustomerDetails />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/document/documentVerify"
          element={
            <AuthRoute
              user={admin}
              element={<ListDocument />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/document/documentVerify/:id"
          element={
            <AuthRoute
              user={admin}
              element={<DocumentVerify />}
              navigate="/admin/login"
            />
          }
        />

        {/* Admin */}
        <Route
          path="/admin/login"
          element={
            isEmptyObj(admin) ? (
              <AdminLogin handleAdmin={handleAdmin} />
            ) : (
              <Navigate to="/admin" />
            )
          }
        />
        <Route
          path="/admin/logout"
          element={
            isEmptyObj(admin) ? (
              <Navigate to="/admin" />
            ) : (
              <AdminLogout setAdmin={setAdmin} />
            )
          }
        />
        <Route
          path="/admin/order"
          element={
            <AuthRoute
              user={admin}
              element={<AdminOrders />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/order-details/:id"
          element={
            <AuthRoute
              user={admin}
              element={<AdminOrderDetails />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/invoice-details/:id"
          element={
            <AuthRoute
              user={admin}
              element={<InvoiceDetail />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/product"
          element={
            <AuthRoute
              user={admin}
              element={<AdminProduct />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/deliveryCharge/deliveryChargeAddNew"
          element={
            <AuthRoute
              user={admin}
              element={<AddDelivery />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/deliveryCharge/deliveryChargeAddNew/:id"
          element={
            <AuthRoute
              user={admin}
              element={<AddDelivery />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/pincode/pincodeAddNew"
          element={
            <AuthRoute
              user={admin}
              element={<AddPincode />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/product/productAddNew"
          element={
            <AuthRoute
              user={admin}
              element={<AddProduct />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/product/view/:id"
          element={
            <AuthRoute
              user={admin}
              element={<AdminViewProduct />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/product/edit/:id"
          element={
            <AuthRoute
              user={admin}
              element={<AdminEditProduct />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/edit-product/:id"
          element={
            <AuthRoute
              user={admin}
              element={<AdminEditProduct />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/profile"
          element={
            <AuthRoute
              user={admin}
              element={<AdminProfile />}
              navigate="/admin/login"
            />
          }
        />
        <Route path="/admin" element={<Navigate to="/admin/dashboard" />} />
        <Route
          path="/admin/dashboard"
          element={
            <AuthRoute
              user={admin}
              element={<AdminDashboard />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/sales/orders"
          element={
            <AuthRoute
              user={admin}
              element={<ShopOrders from="sales" />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/category"
          element={
            <AuthRoute
              user={admin}
              element={<AdminCategory from="catalogue" />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/brand"
          element={
            <AuthRoute
              user={admin}
              element={<AdminBrand from="catalogue" />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/brand/brandAddNew"
          element={
            <AuthRoute
              user={admin}
              element={<AddBrand />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/role/roleAddNew"
          element={
            <AuthRoute
              user={admin}
              element={<AddRole />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/coupon/couponAddNew"
          element={
            <AuthRoute
              user={admin}
              element={<AddCoupon />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/coupon/couponDetails/:id"
          element={
            <AuthRoute
              user={admin}
              element={<CouponDetails />}
              navigate="/admin/login"
            />
          }
        />

        <Route
          path="/admin/coupon/couponList"
          element={
            <AuthRoute
              user={admin}
              element={<ListCoupon />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/category/categoryList"
          element={
            <AuthRoute
              user={admin}
              element={<ListCategory />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/user/userList"
          element={
            <AuthRoute
              user={admin}
              element={<ListUser />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/deliveryCharge/deliveryChargeList"
          element={
            <AuthRoute
              user={admin}
              element={<ListDeliveryCharges />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/pincode/pincodeList"
          element={
            <AuthRoute
              user={admin}
              element={<ListPincode />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/content/contentList"
          element={
            <AuthRoute
              user={admin}
              element={<ListSlide />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/brand/brandList"
          element={
            <AuthRoute
              user={admin}
              element={<ListBrand />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/role/roleList"
          element={
            <AuthRoute
              user={admin}
              element={<ListRole />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/product/productList"
          element={
            <AuthRoute
              user={admin}
              element={<ListProduct />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/sales/payment"
          element={
            <AuthRoute
              user={admin}
              element={<ListPayment />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/sales/payment/:id"
          element={
            <AuthRoute
              user={admin}
              element={<PaymentDetails />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/sales/paymentProof"
          element={
            <AuthRoute
              user={admin}
              element={<ListPaymentProof />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/sales/paymentProof/:id"
          element={
            <AuthRoute
              user={admin}
              element={<PaymentProofReview />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/sales/invoice"
          element={
            <AuthRoute
              user={admin}
              element={<ListInvoice />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/customer/customerList"
          element={
            <AuthRoute
              user={admin}
              element={<ListCustomer />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/customer/customerDetails/:id"
          element={
            <AuthRoute
              user={admin}
              element={<CustomerDetails />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/document/documentVerify"
          element={
            <AuthRoute
              user={admin}
              element={<ListDocument />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/document/documentVerify/:id"
          element={
            <AuthRoute
              user={admin}
              element={<DocumentVerify />}
              navigate="/admin/login"
            />
          }
        />

        <Route
          path="/admin/content/contentAddNew"
          element={
            <AuthRoute
              user={admin}
              element={<AddSlide />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/category/categoryAddNew"
          element={
            <AuthRoute
              user={admin}
              element={<AddCategory />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/user/userAddNew"
          element={
            <AuthRoute
              user={admin}
              element={<AddUser />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/reports/orders"
          element={
            <AuthRoute
              user={admin}
              element={<ShopOrders from="reports" />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/settings"
          element={
            <AuthRoute
              user={admin}
              element={<Settings />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/logs"
          element={
            <AuthRoute
              user={admin}
              element={<AdminLogs />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/audit-log"
          element={
            <AuthRoute
              user={admin}
              element={<ListAuditLog />}
              navigate="/admin/login"
            />
          }
        />
        <Route
          path="/admin/reports/items"
          element={
            <AuthRoute
              user={admin}
              element={<AdminItemsReport />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/admin/reports/products"
          element={
            <AuthRoute
              user={admin}
              element={<AdminProductReport />}
              navigate="/super/login"
            />
          }
        />

        <Route
          path="/admin/Content-homepage"
          element={
            <AuthRoute
              user={admin}
              element={<SuperAdminHomePage />}
              navigate="/admin/login"
            />
          }
        />

        <Route
          path="/admin/edit-user/:id"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SubAdminEditShop />}
              navigate="/super/login"
            />
          }
        />

        {/* Super */}
        <Route
          path="/super/login"
          element={
            isEmptyObj(superAdmin) ? (
              <SuperLogin handleSuperAdmin={handleSuperAdmin} />
            ) : (
              <Navigate to="/super" />
            )
          }
        />
        <Route
          path="/super/logout"
          element={
            isEmptyObj(superAdmin) ? (
              <Navigate to="/super" />
            ) : (
              <SuperAdminLogout setSuperAdmin={setSuperAdmin} />
            )
          }
        />
        <Route
          path="/super/category"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminCategory />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/navigation"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminNavigation />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/service_category"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminServiceCategory />}
              navigate="/super/login"
            />
          }
        />

        <Route
          path="/super/brand"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminBrand />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/add-service-category"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminAddServiceCategory />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/edit-service-category/:id"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminEditServiceCategory />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/add-category"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminAddCategory from="Category" />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/add-navigation"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminAddNavigation from="Navigation" />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/add-brand"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminAddCategory from="Brand" />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/edit-category/:id"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminEditCategory from="Category" />}
              navigate="/super/login"
            />
          }
        />

        <Route
          path="/super/edit-navigation/:id"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminEditNavigation from="Navigation" />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/edit-brand/:id"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminEditCategory from="Brand" />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/user"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminCustomer />}
              navigate="/super/login"
            />
          }
        />
        {/* <Route
                    path="/super/edit-customer/:id"
                    element={<AuthRoute user={superAdmin} element={<CustomerEditForm />} navigate="/super/login" />}
                /> */}

        <Route
          path="/super/notification"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminNotification />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/notificationhistory"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperNotificationForm />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/shop"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminShop />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/add-shop"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminAddShop />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/edit-shop/:id"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminEditShop />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/voucher"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminVoucher />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/add-voucher"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminAddVoucher />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/edit-voucher/:id"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminEditVoucher />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/slide"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminSlide />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/add-slide"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminAddSlide />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/edit-slide/:id"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminEditSlide />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/home_page"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminHomePage />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/settings"
          element={
            <AuthRoute
              user={superAdmin}
              element={<Settings />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/LoyaltyPointsSettings"
          element={
            <AuthRoute
              user={superAdmin}
              element={<LoyaltyPointsSettings />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/sales/orders"
          element={
            <AuthRoute
              user={superAdmin}
              element={<Orders from="sales" />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/reports/orders"
          element={
            <AuthRoute
              user={superAdmin}
              element={<Orders from="reports" />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/sales/invoice"
          element={
            <AuthRoute
              user={superAdmin}
              element={<Invoice from="sales" />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/reports/invoice"
          element={
            <AuthRoute
              user={superAdmin}
              element={<Invoice from="reports" />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/sales/payments"
          element={
            <AuthRoute
              user={superAdmin}
              element={<Payment />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/sales/shipping"
          element={
            <AuthRoute
              user={superAdmin}
              element={<Shipping from="sales" />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/reports/shipping"
          element={
            <AuthRoute
              user={superAdmin}
              element={<Shipping from="reports" />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/sales/tracking"
          element={
            <AuthRoute
              user={superAdmin}
              element={<Tracking />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/products"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminProduct />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/service_or_manpower"
          element={
            <AuthRoute
              user={superAdmin}
              element={<ServiceOrManpower />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/pages"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperPagesComponent />}
              navigate="/super/login"
            />
          }
        />
        {/* <Route
                    path="/super/user_type_permissions"
                    element={<AuthRoute user={superAdmin} element={<CustomerTypePermissions />} navigate="/super/login" />}
                /> */}
        {/* <Route
                    path="/super/loyal_points"
                    element={<AuthRoute user={superAdmin} element={<CustomerLoyaltyPoints />} navigate="/super/login" />}
                /> */}
        <Route
          path="/super/wallet"
          element={
            <AuthRoute
              user={superAdmin}
              element={<Wallet />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/service_orders"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperServiceOrders />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/service_order_details/:id"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperServiceOrderDetails />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/reports/items"
          element={
            <AuthRoute
              user={superAdmin}
              element={<ItemsReport />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/add-product"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminAddProduct />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/reports/products"
          element={
            <AuthRoute
              user={superAdmin}
              element={<ProductReport />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/reports/users_financial"
          element={
            <AuthRoute
              user={superAdmin}
              element={<UserFinancialReport />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/reports/service"
          element={
            <AuthRoute
              user={superAdmin}
              element={<ServiceReport />}
              navigate="/super/login"
            />
          }
        />
        <Route
          path="/super/reports/service_orders"
          element={
            <AuthRoute
              user={superAdmin}
              element={<ServiceItemReport />}
              navigate="/super/login"
            />
          }
        />
        <Route path="/super" element={<Navigate to="/super/dashboard" />} />
        <Route
          path="/super/dashboard"
          element={
            <AuthRoute
              user={superAdmin}
              element={<SuperAdminDashboard />}
              navigate="/super/login"
            />
          }
        />

        {/* user */}
        <Route
          path="/user/user-role"
          element={
            <AuthRoute
              user={admin}
              element={<UsersProfile />}
              navigate="/login"
            />
          }
        />

        {/* <Route exact path="/index-three" element={<HomePageThree />} /> */}
        <Route exact path="/shop" element={<ShopPage />} />

        <Route
          exact
          path="/product-details-two"
          element={<ProductDetailsPageTwo />}
        />
        <Route exact path="/cart" element={<CartPage />} />
        <Route exact path="/become-seller" element={<BecomeSellerPage />} />
        <Route exact path="/wishlist" element={<WishlistPage />} />
        <Route exact path="/account" element={<AccountPage />} />
        <Route exact path="/blog" element={<BlogPage />} />
        <Route exact path="/blog-details" element={<BlogDetailsPage />} />
        <Route exact path="/contact" element={<ContactPage />} />
        <Route exact path="/vendor" element={<VendorPage />} />
        <Route exact path="/vendor-details" element={<VendorDetailsPage />} />
        <Route exact path="/vendor-two" element={<VendorTwoPage />} />
        <Route
          exact
          path="/vendor-two-details"
          element={<VendorTwoDetailsPage />}
        />
      </Routes>
      <div>
        <ToastContainer />
      </div>
    </BrowserRouter>
  );
}
const AuthRoute = ({ user, element, navigate }) => {
  return isEmptyObj(user) ? <Navigate to={navigate} /> : element;
};
export default App;
